import React from 'react';
import { Home, CreditCard, Calendar, Ticket, ShoppingCart, LayoutGrid, Table, Laptop, BookOpen, Users, Smartphone, Inbox, Users2, BarChart2, Bot, LineChart, Settings, Globe, Code, Edit, ChevronRight, ChevronDown } from 'lucide-react';
export const Sidebar = ({
  collapsed
}) => {
  const sidebarWidth = collapsed ? 'w-16' : 'w-56';
  return <aside className={`${sidebarWidth} transition-width duration-300 bg-gray-900 text-gray-100 flex flex-col h-full overflow-y-auto`} data-id="element-1498">
      <div className="py-4 border-b border-gray-800" data-id="element-1499">
        <div className="px-4 flex items-center" data-id="element-1500">
          <span className={`text-xs font-medium ${collapsed ? 'hidden' : 'block'}`} data-id="element-1501">
            Quick Actions
          </span>
        </div>
      </div>
      <div className="py-4 border-b border-gray-800" data-id="element-1502">
        <div className="px-4 flex items-center" data-id="element-1503">
          <span className={`text-xs font-medium ${collapsed ? 'hidden' : 'block'}`} data-id="element-1504">
            Get 250 monthly visitors
          </span>
        </div>
        <div className="px-4 mt-2" data-id="element-1505">
          <div className="text-xs text-gray-400" data-id="element-1506">15/250 visitors</div>
          <div className="mt-1 h-1 bg-gray-700 rounded-full" data-id="element-1507">
            <div className="h-1 bg-gray-400 rounded-full" style={{
            width: '6%'
          }} data-id="element-1508"></div>
          </div>
        </div>
      </div>
      <nav className="flex-1 py-2" data-id="element-1509">
        <SidebarItem icon={<Home size={18} data-id="element-1511" />} label="Home" collapsed={collapsed} data-id="element-1510" />
        <SidebarItem icon={<CreditCard size={18} data-id="element-1513" />} label="Getting Paid" collapsed={collapsed} hasSubmenu data-id="element-1512" />
        <SidebarItem icon={<Calendar size={18} data-id="element-1515" />} label="Booking Calendar" collapsed={collapsed} hasSubmenu data-id="element-1514" />
        <SidebarItem icon={<Ticket size={18} data-id="element-1517" />} label="Events" collapsed={collapsed} hasSubmenu data-id="element-1516" />
        <SidebarItem icon={<ShoppingCart size={18} data-id="element-1519" />} label="Sales" collapsed={collapsed} data-id="element-1518" />
        <SidebarItem icon={<LayoutGrid size={18} data-id="element-1521" />} label="Catalog" collapsed={collapsed} hasSubmenu data-id="element-1520" />
        <SidebarItem icon={<Table size={18} data-id="element-1523" />} label="Table Reservations" collapsed={collapsed} data-id="element-1522" />
        <SidebarItem icon={<Laptop size={18} data-id="element-1525" />} label="Online Programs" collapsed={collapsed} hasSubmenu data-id="element-1524" />
        <SidebarItem icon={<BookOpen size={18} data-id="element-1527" />} label="Blog" collapsed={collapsed} hasSubmenu data-id="element-1526" />
        <SidebarItem icon={<Users size={18} data-id="element-1529" />} label="Groups" collapsed={collapsed} data-id="element-1528" />
        <SidebarItem icon={<Smartphone size={18} data-id="element-1531" />} label="Site & Mobile App" collapsed={collapsed} data-id="element-1530" />
        <SidebarItem icon={<Inbox size={18} data-id="element-1533" />} label="Inbox" collapsed={collapsed} data-id="element-1532" />
        <SidebarItem icon={<Users2 size={18} data-id="element-1535" />} label="Customers & Leads" collapsed={collapsed} hasSubmenu data-id="element-1534" />
        <SidebarItem icon={<BarChart2 size={18} data-id="element-1537" />} label="Marketing" collapsed={collapsed} hasSubmenu data-id="element-1536" />
        <SidebarItem icon={<Bot size={18} data-id="element-1539" />} label="AI Agents" collapsed={collapsed} hasSubmenu isExpanded active data-id="element-1538" />
        <div className={`pl-${collapsed ? '0' : '8'} ${collapsed ? 'items-center' : ''} flex`} data-id="element-1540">
          <div className={`flex items-center py-2 px-${collapsed ? '4' : '2'} rounded-md ${collapsed ? 'justify-center' : ''}`} data-id="element-1541">
            {collapsed ? null : <div className="w-5" data-id="element-1542" />}
            <span className={`text-sm ${collapsed ? 'hidden' : 'block'}`} data-id="element-1543">
              AI Marketing Agent
            </span>
          </div>
        </div>
        <div className={`pl-${collapsed ? '0' : '8'} ${collapsed ? 'items-center' : ''} flex`} data-id="element-1544">
          <div className={`flex items-center py-2 px-${collapsed ? '4' : '2'} bg-gray-700 rounded-md ${collapsed ? 'justify-center' : ''}`} data-id="element-1545">
            {collapsed ? null : <div className="w-5" data-id="element-1546" />}
            <span className={`text-sm ${collapsed ? 'hidden' : 'block'}`} data-id="element-1547">
              AI Custom Agent
            </span>
          </div>
        </div>
        <SidebarItem icon={<LineChart size={18} data-id="element-1549" />} label="Analytics" collapsed={collapsed} hasSubmenu data-id="element-1548" />
        <SidebarItem icon={<Settings size={18} data-id="element-1551" />} label="Automations" collapsed={collapsed} hasSubmenu data-id="element-1550" />
        <SidebarItem icon={<Settings size={18} data-id="element-1553" />} label="Settings" collapsed={collapsed} data-id="element-1552" />
        <SidebarItem icon={<Globe size={18} data-id="element-1555" />} label="Website Content" collapsed={collapsed} hasSubmenu data-id="element-1554" />
        <SidebarItem icon={<Code size={18} data-id="element-1557" />} label="Developer Tools" collapsed={collapsed} hasSubmenu data-id="element-1556" />
      </nav>
      <div className="mt-auto border-t border-gray-800 py-3 px-4 flex items-center" data-id="element-1558">
        <Edit size={16} className="text-gray-400 mr-2" data-id="element-1559" />
        <span className={`text-sm ${collapsed ? 'hidden' : 'block'}`} data-id="element-1560">
          Edit Site
        </span>
      </div>
    </aside>;
};
const SidebarItem = ({
  icon,
  label,
  hasSubmenu = false,
  isExpanded = false,
  active = false,
  collapsed
}) => {
  return <div className={`flex items-center py-2 px-4 ${active ? 'bg-gray-800' : 'hover:bg-gray-800'} rounded-md ${collapsed ? 'justify-center' : ''}`} data-id="element-1561">
      <div className="text-gray-400" data-id="element-1562">{icon}</div>
      {!collapsed && <>
          <span className="ml-3 text-sm" data-id="element-1563">{label}</span>
          {hasSubmenu && <div className="ml-auto text-gray-500" data-id="element-1564">
              {isExpanded ? <ChevronDown size={14} data-id="element-1565" /> : <ChevronRight size={14} data-id="element-1566" />}
            </div>}
        </>}
    </div>;
};